import React from 'react'
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import GroupIcon from '@mui/icons-material/Group';
import HotelIcon from '@mui/icons-material/Hotel';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import StorefrontIcon from '@mui/icons-material/Storefront';
import NightlifeIcon from '@mui/icons-material/Nightlife';

export const IconByCategory = ({ category, fontSize = "small",style }: { category: string, fontSize?: any,style?:any }) => {
    switch (category) {
        case 'Entertainment':
            return <VideoLibraryIcon style={style}  fontSize={fontSize} />
        case 'Clubs':
            return <GroupIcon style={style} fontSize={fontSize} />
        case 'Retail':
            return <StorefrontIcon style={style} fontSize={fontSize} />
        case 'Restaurants':
            return <RestaurantMenuIcon style={style} fontSize={fontSize} />
        case 'Hotels':
            return <HotelIcon  style={style} fontSize={fontSize} />
        case 'Events':
            return <EventAvailableIcon style={style} fontSize={fontSize}/>
        case 'Nightlife':
            return <NightlifeIcon style={style} fontSize={fontSize}/>
        default:
            return <EventAvailableIcon style={style} fontSize={fontSize}/>
    }
}
